<script>
  import { createEventDispatcher } from 'svelte';
  import { fly } from 'svelte/transition';
  import FormDropdown from '../components/FormDropdown.svelte';

  import { formData } from '../stores/formDataStore';

  import { requiredString } from '../utils/validation';

  export let visible;

  const dispatch = createEventDispatcher();

  const otherOpts = ['Yes', 'No'];

  let data = {
    otherConsultants: { value: '', error: false, validation: requiredString },
  };

  let error = false;

  let experienceImprovements = '';
  let experienceExtraInfo = '';
  let areaExtraInfo = '';

  const handleClick = () => {
    error = false;
    Object.keys(data).forEach((key) => {
      const keyData = data[key];
      const valid = keyData.validation(keyData.value);
      if (valid) {
        data = { ...data, [key]: { ...keyData, error: false } };
      } else {
        error = true;
        data = { ...data, [key]: { ...keyData, error: true } };
      }
    });
    if (!error) {
      const newData = {
        otherConsultants: data.otherConsultants.value,
        experienceImprovements,
        experienceExtraInfo,
        areaExtraInfo,
      };
      formData.updateFormData(newData);
      dispatch('changePage', { page: 'page4' });
    }
  };
</script>

{#if visible}
  <div
    class="feedback-page-3 feedback-el"
    in:fly={{ x: 600, duration: 600 }}
    out:fly={{ x: -600, duration: 600 }}>
    <h1 class="main-heading mb-default">Performance</h1>
    <FormDropdown
      options={otherOpts}
      placeholder="Have you used other environmental consultants previously?"
      error={data.otherConsultants.error}
      bind:chosenOpt={data.otherConsultants.value} />
    <label class="form-label" for="experience-improvements">What would have made
      your experience with us better?</label>
    <textarea
      name="experience-improvements"
      id="experience-improvements"
      class="form-input"
      placeholder={'What would have made your experience with us better?'}
      bind:value={experienceImprovements} />
    <label class="form-label" for="experience-extra-info">Is there anything else
      you would like us to know about your experience?</label>
    <textarea
      name="experience-extra-info"
      id="experience-extra-info"
      class="form-input"
      placeholder={'Is there anything else you would like us to know about your experience?'}
      bind:value={experienceExtraInfo} />
    <label class="form-label" for="area-extra-info">Would you like to receive
      any specific information relating any of the services we offer?</label>
    <textarea
      name="area-extra-info"
      id="area-extra-info"
      class="form-input"
      placeholder={'Would you like to receive any specific information relating any of the services we offer?'}
      bind:value={areaExtraInfo} />
    <button class="btn base bold block centered" on:click={handleClick}>Continue
      Survey</button>
  </div>
{/if}
